/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

let $ = jQuery;
import {
	OKEVENT,
	subscribeToOkEvent,
} from "shared/util/OkEventHelpers";
import Context from "shared/util/Context";
import getImageResizerPath from "shared/util/getImageResizerPath";
import KeyName from "legacy/keynames";

//#############################
/* OKPHOTOS PANEL HANDLER */
//#############################

const OkPhotos = {
	// Photo state properties
	currentAction: null,

	requests: [],

	// Profile photo specifics
	maxPhotos: 10,

	photoCount: 0,
	maxAlbumPhotos: 40,
	albumPhotoCount: 0,

	// Should match up with OkPhotos.scss
	animSpeedShort: 125,

	animSpeed: 225,
	animSpeedLong: 600,

	// Support properties
	support: {
		basic: false,
		upload: false,
		ajaxupload: false,
		dragndrop: false,
		facebook: false,
		dropbox: false,
	},

	// Photo upload properties
	minSize: 400,

	currentAlbum: 0,
	maxPics: 10,
	fileTypes: ["jpg", "jpeg", "gif", "png", "webp"],

	// Crop settings
	cropSettings: {
		aspectRatio: 1,
		handles: "diagonal",
		cropMin: { width: 250, height: 250 },
	},

	// Init function params
	action: "upload",

	referrer: "upload",
	userid: Context.get("userid"),
	authcode: "0",

	// Shim for old okphotos. init = open.
	init(params) {
		if (params == null) {
			params = {};
		}

		if (params.referrer) {
			this.referrer = params.referrer;
		}

		PhotoUploader.albumid = 0;

		if (
			(typeof ProfilePhotos !== "undefined" && ProfilePhotos !== null
				? ProfilePhotos.current_album
				: undefined) != null &&
			ProfilePhotos.current_album !== "0"
		) {
			PhotoUploader.albumid = ProfilePhotos.current_album;
			PhotoUploader.setRules(PhotoUploader.ruleTypes.album);
		} else {
			PhotoUploader.setRules(PhotoUploader.ruleTypes.profile);
		}

		if (
			(!PhotoUploader.albumid && this.photoCount >= this.maxPhotos) ||
			(PhotoUploader.albumid && this.albumPhotoCount >= this.maxAlbumPhotos)
		) {
			FeedbackBanner.open({
				type: "error",
				message: PhotoUtil.ERROR_INFO[PhotoUtil.ERRORS.FULL].desc,
				timeout: 2500,
			});
			return;
		}

		this.open("upload");
		this.startTime = new Date().getTime();

		// Explicitly return undefined, because some dickheads snuck this init
		// call in to hrefs, which Firefox doesn't like return values on.
		return undefined;
	},

	// Params:
	//	userid	 (string) - A user ID for photo reading (Not writing.)
	//	authcode (string) - The authcode for uploading photos.
	initialize(params) {
		if (params == null) {
			params = {};
		}

		if (this.initialized) {
			return;
		}

		// Initialize vars
		this.checkSupport();
		$.extend(this, params);
		this.container = $("#okphotos_overlay");
		this.closeBtn = $("#okphotos_action_close, #okphotos_viewer_close");

		this.initError();
		this.getPage();

		// Actions properties
		this.actionInitializers = {
			upload: () => {
				PhotoUploader.init();
				PhotoTiles.init();
				PhotoEditor.init();
				PhotoFinished.init();
			},

			finished: () => {
				PhotoFinished.setMessage();
			},
		};

		// Set if self view
		if (Context.get("userid") === this.userid) {
			this.self = true;
		}

		// Bind a few basic / shared events
		this.closeBtn.on("click", () => {
			this.close();
		});
		$(window).on("resize focus", () => {
			this.centerAction();
		});
		$(document).on("keydown", e => {
			if (!this.isOpen()) {
				return;
			}

			if (e.which === KeyName.ESCAPE) {
				this.close();
			}
		});

		// Bind to photo okevents
		subscribeToOkEvent(OKEVENT.PhotoUpload, ev => {
			OkPhotos.alterPhotoCount(1);

			if (!ev.photo.albumid) {
				OkPhotos.handlePrimarySwap(ev.photo.path, true);
			}
		});
		subscribeToOkEvent(OKEVENT.PhotoDelete, ev => {
			if (!ev.photo.albumid) {
				OkPhotos.alterPhotoCount(-1);
			}
		});

		this.initialized = true;
	},

	// Initialize error-related things
	initError() {
		this.errorBtn = $("#okphotos_error button");
		this.errorMsg = $("#okphotos_error .message");
		this.errorBtn.on("click", () => {
			this.switchAction(this.errorActionName);
		});
	},

	open(action) {
		if (action) {
			this.switchAction(action);
		}

		clearTimeout(this.closeTimeout);
		this.container.show();

		this.container.height();
		if (!this.container.hasClass("show")) {
			ClientStats.update({
				statnames: [
					"OkPhotos - opened",
					`OkPhotos - opened - referrer:${this.referrer}`
				],
			});
			this.container.addClass("show");
		}

		$("body").addClass("noscroll");

		setTimeout(() => {
			$("body").addClass("blur");
		}, this.animSpeed * 0.7);
	},

	close() {
		this.container.removeClass("show");
		$("body").removeClass("blur noscroll");

		clearTimeout(this.closeTimeout);

		this.closeTimeout = setTimeout(() => {
			// Post stats
			let statnames = [
				"OkPhotos - closed",
				`OkPhotos - closed - ${this.currentActionName}`,
			];

			if (this.currentActionName === "photo_tiles") {
				statnames.push(`OkPhotos - closed - photo_tiles - ${PhotoTiles.service}`);
			}

			ClientStats.update({ statnames });

			// Hide container
			this.container.hide();
		}, this.container.transitionSpeed());
	},

	openPhoto(picid) {
		this.open("viewer");
	},

	// Resets the state of everything in upload so the next one is clean
	reset() {
		PhotoUploader.albumid = null;
		PhotoUploader.newAlbum = null;
		this.close();
	},

	// Check if the panel is open, optionally a specific action
	isOpen(action) {
		if (this.container == null) {
			return;
		}

		if (!this.container.hasClass("show")) {
			return false;
		}

		if (action) {
			return this.container.is(":visible") && this.currentActionName === action;
		}

		return this.container.is(":visible");
	},

	// Switch to another action (or step) of the photo upload process. Also hides
	// the loader, so feel free to leave showLoader() going before calling this.
	//
	// action	(string) - Name of the action to switch to. Corresponds to the
	//										#okphotos_#{action} element.
	// direction (bool) - Positive for forward, negative for backward. Optional.
	switchAction(action, direction) {
		let actionEl = $(`#okphotos_${action}`);
		if (!actionEl.length) {
			return;
		}

		if (this.currentAction) {
			if (actionEl.attr("id") === this.currentAction.attr("id")) {
				this.hideLoader();
				return;
			}

			let oldActionName = this.currentActionName;
			this.currentAction.fadeOut(this.animSpeed / 2, () => {
				this.container.addClass(action).removeClass(oldActionName);
				this.currentAction.removeClass("active");
				actionEl.fadeIn(this.animSpeed / 2);
				actionEl.addClass("active");
				this.centerAction();
				this.hideLoader();
			});
		} else {
			actionEl.show();
			this.container.addClass(action);
			this.hideLoader();
		}

		if (this.actionInitializers[action]) {
			this.actionInitializers[action]();
			this.actionInitializers[action] = false;
		}

		this.currentAction = actionEl;
		this.currentActionName = action;
		this.centerAction();
	},

	// Center the part of the current action that needs centering, if specified.
	centerAction() {
		if (!this.currentAction) {
			return;
		}

		let centered = this.currentAction.find(".centered");

		if (centered.length) {
			let panelHeight = $("#okpanel").height();
			centered.css(
				"margin-top",
				Math.round(Math.max(panelHeight / 2 - centered.height() / 2 - 40, 0))
			);
		}
	},

	// Show / hide AJAX loader.
	showLoader() {
		if (!this.loader && $("#okphotos_action_area").length) {
			this.loader = new OkLoader(
				$("#okphotos_action_area"),
				{
					size: "small",
				},
			);
		}

		if (this.loader) {
			this.loader.start();
		}
	},

	hideLoader() {
		if (!this.loader) {
			return;
		}

		this.loader.stop();
	},

	// Clear all active requests
	clearRequests() {
		let requests;

		for (let request of this.requests) {
			request.abort;
		}

		this.requests = [];
	},

	// Upon changing photos, we need to update it everywhere on the page
	handlePrimarySwap(path, newPhoto) {
		this.getPage();

		// Sidebar image
		$("#user img").attr("src", getImageResizerPath() + "/120x120/120x120/" + path);

		// Profile sidebar photo
		if (this.page === "profile") {
			$("#profile_sidebar .user_image img").attr(
				"src",
				getImageResizerPath() + "/225x225/225x225/" + path
			);
		}
	},

	/* HELPER FUNCTIONS */

	// Check for support of okphotos functionality.
	checkSupport() {
		if (this.support.checked) {
			return;
		}

		this.support.basic = true;
		this.support.upload = true;
		this.support.dropbox = true;
		this.support.facebook = true;
		this.support.instagram = true;

		if (window.FileReader) {
			this.support.dragndrop = true;
			this.support.ajaxupload = true;
		}

		this.support.checked = true;
	},

	// Gets the current page you're on, only photos or profile matter.
	getPage() {
		if (this.page) {
			return this.page;
		}

		let path = window.location.pathname;
		let pathPieces = path.split("/");
		const userid = Context.get("userid");

		if (
			pathPieces[2] &&
			pathPieces[2].toLowerCase() === userid
		) {
			this.page = "profile";
		} else if (
			(pathPieces[1] === "profile" || pathPieces[1] === "questions") &&
			!pathPieces[2]
		) {
			this.page = "profile";
		} else {
			this.page = "other";
		}

		return this.page;
	},

	// Update the photo count (Profile only, albums don't count.) And set a
	// class accordingly. Value is added, not set.
	alterPhotoCount(val) {
		this.photoCount += val;
		this.container.removeClass("full_photos no_photos");

		if (!PhotoUploader.albumid && this.photoCount >= this.maxPhotos) {
			this.container.addClass("full_photos");
		} else if (!this.photoCount) {
			this.container.addClass("no_photos");
		}
	},

	// Actually set the photo count.
	setPhotoCount(val) {
		this.photoCount = val;
		this.alterPhotoCount(0);
	},

	// Return whether or not we're full on photos
	isFull() {
		return this.photoCount >= this.maxPhotos;
	},

	getSuccessMessage() {
		let messages = [_str("You look great!")];

		// since More Photos pics don't necessary have you in it, change the message
		// to not refer to "you".
		if (
			(typeof ProfilePhotos !== "undefined" && ProfilePhotos !== null
				? ProfilePhotos.current_album
				: undefined) != null &&
			(typeof ProfilePhotos !== "undefined" && ProfilePhotos !== null
				? ProfilePhotos.current_album
				: undefined) !== "0" ||
			(PhotoUploader.albumid && PhotoUploader.albumid !== "0")
		) {
			messages = [_str("Nice!")];
		}

		return messages[Math.floor(Math.random() * messages.length)];
	},

	/* ERRORS */

	// Show an error. Errors are defined in photoutil.
	showError(type) {
		if (!type || !PhotoUtil.ERROR_INFO[type]) {
			type = "default";
		}

		ClientStats.update({
			statnames: [
				"OkPhotos - error",
				`OkPhotos - error - ${type}`,
			],
		});

		// Trigger any uploaderror events. If one of the callbacks called
		// OkPhotos.close(), let it do its thang.
		$(document).trigger({
			type: "okphotos.uploaderror",
			errorType: type,
		});

		if (!OkPhotos.isOpen()) {
			return;
		}

		this.errorActionName = this.currentActionName;
		this.switchAction("upload");
		this.hideLoader();

		FeedbackBanner.open({
			type: "error",
			message: PhotoUtil.ERROR_INFO[type].desc,
			timeout: 3200,
		});
	},
};

window.OkPhotos = OkPhotos;

export default OkPhotos;



// WEBPACK FOOTER //
// ./src/legacy/okphotos/okphotos.js